import { render, staticRenderFns } from "./ApexDataBarChart.vue?vue&type=template&id=1b72ebec&scoped=true&"
import script from "./ApexDataBarChart.vue?vue&type=script&lang=js&"
export * from "./ApexDataBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexDataBarChart.vue?vue&type=style&index=0&id=1b72ebec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72ebec",
  null
  
)

export default component.exports